{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-750000",
  "sheetId": "NotesRelatedPartyTransactions",
  "label": "[750000] Notes - Related Party Transactions",
  "description": "Disclosure of related party relationships, transactions, and outstanding balances (MPERS)",
  "columnSumValidations": [
    {
      "subTotalColumnQname": "Total",
      "componentColumnQnames": [
        "ssmt-mpers:ParentMember",
        "ifrs-smes:JointControlOrSignificantInfluenceMember",
        "ssmt-mpers:SubsidiariesMember",
        "ssmt-mpers:AssociatesMember",
        "ssmt-mpers:JointVenturesWhereEntityIsVenturerMember",
        "ifrs-smes:KeyManagementPersonnelOfEntityOrParentMember",
        "ifrs-smes:OtherRelatedPartiesMember"
      ],
      "subTotalLabel": "Total related party",
      "componentLabels": [
        "Parent",
        "Entities with joint control or significant influence",
        "Subsidiaries",
        "Associates",
        "Joint ventures where entity is venturer",
        "Key management personnel",
        "Other related party"
      ],
      "appliesToRowQnames": [
        "ssmt-mpers:RelatedPartyTransactionsContributionToFund",
        "ssmt-mpers:RelatedPartyTransactionsDisposalOfSubsidiaries",
        "ssmt-mpers:DividendIncomeRelatedPartyTransactions",
        "ssmt-mpers:InterestIncomeRelatedPartyTransactions",
        "ssmt-mpers:RelatedPartyTransactionsIssueOfSharesForExchangeableBonds",
        "ifrs-smes:KeyManagementPersonnelCompensation",
        "ssmt-mpers:RelatedPartyTransactionsKeyManagementPersonnelServiceFees",
        "ssmt-mpers:RelatedPartyTransactionsManagementFees",
        "ssmt-mpers:OtherExpensesRecognisedForTransactionsWithRelatedParties",
        "ssmt-mpers:RelatedPartyTransactionsOtherKeyManagementPersonnel",
        "ssmt-mpers:OtherRevenueRecognisedForTransactionsWithRelatedParties",
        "ssmt-mpers:RelatedPartyTransactionsEducationAndStaffTrainingServices",
        "ssmt-mpers:RelatedPartyTransactionsLeasingAndHirePurchaseFacilities",
        "ifrs-smes:PurchasesOfGoodsRelatedPartyTransactions",
        "ifrs-smes:PurchasesOfPropertyAndOtherAssetsRelatedPartyTransactions",
        "ssmt-mpers:RentalExpensesRelatedPartyTransactions",
        "ssmt-mpers:RelatedPartyTransactionsRentalIncome",
        "ifrs-smes:RevenueFromSaleOfGoodsRelatedPartyTransactions",
        "ifrs-smes:RevenueFromRenderingOfServicesRelatedPartyTransactions",
        "ssmt-mpers:RelatedPartyTransactionsRoyaltyExpenses",
        "ssmt-mpers:RelatedPartyTransactionsRoyaltyIncome",
        "ifrs-smes:SalesOfPropertyAndOtherAssetsRelatedPartyTransactions",
        "ifrs-smes:ServicesReceivedRelatedPartyTransactions",
        "ssmt-mpers:RelatedPartyTransactionsShareOptionRecharged",
        "ssmt-mpers:RelatedPartyTransactionsShareBasedPaymentTransactions",
        "ssmt-mpers:RelatedPartyTransactionsSupplementaryPaymentsAndSignatureBonus",
        "ssmt-mpers:RelatedPartyTransactionsTransactionsWithShareholdersAndGovernments",
        "ssmt-mpers:OtherTransactionsWithRelatedParties",
        "ifrs-smes:AmountsPayableRelatedPartyTransactions",
        "ifrs-smes:AmountsReceivableRelatedPartyTransactions",
        "ssmt-mpers:OtherBalancesWithRelatedParties"
      ]
    }
  ],
  "controls": [
    {
      "qname": "ssmt-mpers:DisclosureOnRelatedPartyTransactionsAbstract",
      "label": "Disclosure on related party transactions",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfTransactionsBetweenRelatedPartiesExplanatory",
      "label": "Disclosure of transactions between related parties",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 8
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfTransactionsBetweenRelatedPartiesHeader",
      "label": "Disclosure of transactions between related parties",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfTransactionsBetweenRelatedPartiesLevel3Header",
      "label": "Disclosure of transactions between related parties",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsHeader",
      "label": "Related party transactions",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsContributionToFund",
      "label": "Contribution to fund",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsDisposalOfSubsidiaries",
      "label": "Disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DividendIncomeRelatedPartyTransactions",
      "label": "Dividend income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InterestIncomeRelatedPartyTransactions",
      "label": "Interest income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsIssueOfSharesForExchangeableBonds",
      "label": "Issue of shares for exchangeable bonds",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-smes:KeyManagementPersonnelCompensation",
      "label": "Key management personnel",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsKeyManagementPersonnelServiceFees",
      "label": "Key management personnel services fee",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsManagementFees",
      "label": "Management fees",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherExpensesRecognisedForTransactionsWithRelatedParties",
      "label": "Other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsOtherKeyManagementPersonnel",
      "label": "Other key management personnel",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherRevenueRecognisedForTransactionsWithRelatedParties",
      "label": "Other revenue",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsEducationAndStaffTrainingServices",
      "label": "Provision of education and staff training services",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsLeasingAndHirePurchaseFacilities",
      "label": "Provision of leasing and hire purchase facilities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-smes:PurchasesOfGoodsRelatedPartyTransactions",
      "label": "Purchases of goods",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-smes:PurchasesOfPropertyAndOtherAssetsRelatedPartyTransactions",
      "label": "Purchases of property and other assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RentalExpensesRelatedPartyTransactions",
      "label": "Rental expense",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsRentalIncome",
      "label": "Rental income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-smes:RevenueFromRenderingOfServicesRelatedPartyTransactions",
      "label": "Revenue from rendering of services",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-smes:RevenueFromSaleOfGoodsRelatedPartyTransactions",
      "label": "Revenue from sale of goods",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsRoyaltyExpenses",
      "label": "Royalty expense",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsRoyaltyIncome",
      "label": "Royalty income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-smes:SalesOfPropertyAndOtherAssetsRelatedPartyTransactions",
      "label": "Sales of property and other assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ServicesReceivedRelatedPartyTransactions",
      "label": "Services received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsShareOptionRecharged",
      "label": "Share options recharged",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsShareBasedPaymentTransactions",
      "label": "Share-based payment transactions",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsSupplementaryPaymentsAndSignatureBonus",
      "label": "Supplemental payments and signature bonus",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyTransactionsTransactionsWithShareholdersAndGovernments",
      "label": "Transactions with shareholders and governments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherTransactionsWithRelatedParties",
      "label": "Other related parties transaction",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OutstandingBalancesForRelatedPartyTransactionsHeader",
      "label": "Outstanding balances for related party transactions",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-smes:AmountsPayableRelatedPartyTransactions",
      "label": "Amounts payable",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-smes:AmountsReceivableRelatedPartyTransactions",
      "label": "Amounts receivable",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherBalancesWithRelatedParties",
      "label": "Other outstanding balances",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RelatedPartyRelationshipsHeader",
      "label": "Related party relationships",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfRelatedPartyRelationships",
      "label": "Description of related party relationships",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 5,
        "placeholder": "Describe the nature of related party relationships"
      }
    },
    {
      "qname": "ssmt-mpers:ParentAndSubsidiariesHeader",
      "label": "Parent and Subsidiaries",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithParentCompany",
      "label": "Are there transactions with parent company?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfTransactionsWithParentCompany",
      "label": "Description of transactions with parent company",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithParentCompany",
        "conditionalValue": "Yes",
        "placeholder": "Describe the nature and amounts of transactions"
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfTransactionsWithParentCompany",
      "label": "Amount of transactions with parent company",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithParentCompany",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:OutstandingBalanceWithParentCompany",
      "label": "Outstanding balance with parent company",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithParentCompany",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithSubsidiaries",
      "label": "Are there transactions with subsidiaries?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfTransactionsWithSubsidiaries",
      "label": "Description of transactions with subsidiaries",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithSubsidiaries",
        "conditionalValue": "Yes",
        "placeholder": "Describe the transactions"
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfTransactionsWithSubsidiaries",
      "label": "Amount of transactions with subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithSubsidiaries",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:OutstandingBalanceWithSubsidiaries",
      "label": "Outstanding balance with subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithSubsidiaries",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:AssociatesAndJointVenturesHeader",
      "label": "Associates and Joint Ventures",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithAssociates",
      "label": "Are there transactions with associates?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfTransactionsWithAssociates",
      "label": "Description of transactions with associates",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithAssociates",
        "conditionalValue": "Yes",
        "placeholder": "Describe the transactions"
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfTransactionsWithAssociates",
      "label": "Amount of transactions with associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithAssociates",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:OutstandingBalanceWithAssociates",
      "label": "Outstanding balance with associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithAssociates",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithJointVentures",
      "label": "Are there transactions with joint ventures?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfTransactionsWithJointVentures",
      "label": "Description of transactions with joint ventures",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithJointVentures",
        "conditionalValue": "Yes",
        "placeholder": "Describe the transactions"
      }
    },
    {
      "qname": "ssmt-mpers:AmountOfTransactionsWithJointVentures",
      "label": "Amount of transactions with joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithJointVentures",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:OutstandingBalanceWithJointVentures",
      "label": "Outstanding balance with joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithJointVentures",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:KeyManagementPersonnelHeader",
      "label": "Key Management Personnel Compensation",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:ShortTermEmployeeBenefitsToKeyManagementPersonnel",
      "label": "Short-term employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:PostEmploymentBenefitsToKeyManagementPersonnel",
      "label": "Post-employment benefits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:OtherLongTermBenefitsToKeyManagementPersonnel",
      "label": "Other long-term benefits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:TerminationBenefitsToKeyManagementPersonnel",
      "label": "Termination benefits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:ShareBasedPaymentsToKeyManagementPersonnel",
      "label": "Share-based payments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:TotalCompensationToKeyManagementPersonnel",
      "label": "Total compensation to key management personnel",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:DirectorsRemunerationHeader",
      "label": "Directors' Remuneration",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:DirectorsFees",
      "label": "Directors' fees",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:DirectorsSalariesAndBonuses",
      "label": "Directors' salaries and bonuses",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:DirectorsEPFContributions",
      "label": "Directors' EPF contributions",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:DirectorsOtherEmoluments",
      "label": "Directors' other emoluments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:TotalDirectorsRemuneration",
      "label": "Total directors' remuneration",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mpers:OtherRelatedPartiesHeader",
      "label": "Other Related Parties",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithOtherRelatedParties",
      "label": "Are there transactions with other related parties?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfOtherRelatedPartyTransactions",
      "label": "Description of other related party transactions",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 5,
        "conditionalOn": "ssmt-mpers:DisclosureOfWhetherThereAreTransactionsWithOtherRelatedParties",
        "conditionalValue": "Yes",
        "placeholder": "Describe transactions with other related parties"
      }
    },
    {
      "qname": "ssmt-mpers:AdditionalDisclosuresHeader",
      "label": "Additional Disclosures",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfTermsAndConditionsOfRelatedPartyTransactions",
      "label": "Terms and conditions of related party transactions",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "placeholder": "Describe terms, conditions, and whether transactions are at arm's length"
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfGuaranteesProvidedOrReceived",
      "label": "Guarantees provided or received",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 3,
        "placeholder": "Describe any guarantees with related parties"
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfWriteOffsOrAllowances",
      "label": "Write-offs or allowances for related party balances",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 3,
        "placeholder": "Describe any write-offs or allowances"
      }
    }
  ]
}
